const Footer = () => {
    const currentYear = new Date().getFullYear();
  return (
    <footer className="w-full" aria-labelledby="footer-heading">
        <h2 id="footer-heading" className="sr-only">Footer</h2>
        <div className="p-4 mx-auto max-w-7xl sm:px-6 lg:px-16">
            <div className="flex flex-col items-baseline space-y-6">
                <div className="mx-auto">
                    <span className="mx-auto text-sm text-slate-500">
                        Copyright © 2020 - {currentYear}
                        <a href="https://medcrum.com/" className="mx-2 text-blue-500 hover:text-gray-500" rel="noopener noreferrer">MedCrum</a>
                    </span>
                </div>
            </div>
        </div>
    </footer>
  )
}

export default Footer
